// eslint-disable-next-line import/prefer-default-export
export const SNACKBAR_MESSAGES_SET = (state, { message }) => ({
  ...state,
  messages: [...state.messages, message]
});

export const SNACKBAR_MESSAGES_DEL = (state, { uid }) => ({
  ...state,
  messages: state.messages.filter((msg) => msg.uid !== uid)
});
